import { RouteConfig } from 'vue-router'
import { authRoutesConfig } from '@/features/auth/auth.router'
import { uploadRoutesConfig } from '@/features/upload/upload.router'
import { projectListRoutesConfig } from '@/features/projectList/projectList.router'
import { matchFieldsRoutesConfig } from '@/features/matchFields/matchFields.router'
import { jobRoutesConfig, jobRoutesByUuidConfig } from '@/features/job/job.router'
import { processingRoutesConfig } from '@/features/processing/processing.router'

export const routes: RouteConfig[] = [
  {
    path: '/callback',
    component: () => import('@/features/auth0/components/Callback.vue')
  },
  {
    path: '/',
    component: () => import('@/system/layouts/Auth.vue'),
    children: [
      ...jobRoutesByUuidConfig,
      ...authRoutesConfig
    ]
  },
  {
    path: '/',
    component: () => import('@/system/layouts/General.vue'),
    children: [
      ...uploadRoutesConfig,
      ...projectListRoutesConfig,
      ...matchFieldsRoutesConfig,
      ...jobRoutesConfig,
      ...processingRoutesConfig
    ]
  }
]
